(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const money = (cents, currency) => {
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP',
      }).format((cents || 0) / 100);
    } catch (e) {
      return `£${((cents || 0) / 100).toFixed(2)}`;
    }
  };

  const updateCartCount = (count) => {
    document.querySelectorAll('.croft-cart-count').forEach((el) => {
      if (count > 0) {
        el.textContent = count;
        el.hidden = false;
      } else {
        el.hidden = true;
      }
    });

    document.querySelectorAll('.croft-cart-btn').forEach((btn) => {
      let badge = btn.querySelector('.croft-cart-count');
      if (count > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'croft-cart-count';
          btn.appendChild(badge);
        }
        badge.hidden = false;
        badge.textContent = count;
      } else if (badge) {
        badge.hidden = true;
      }
    });
  };

  const getPopup = () => document.getElementById('CroftCartPopup');

  const openPopup = (item, cart) => {
    const popup = getPopup();
    if (!popup || !item) return;

    const img = document.getElementById('CroftCartPopupImage');
    const name = document.getElementById('CroftCartPopupName');
    const price = document.getElementById('CroftCartPopupPrice');
    const qty = document.getElementById('CroftCartPopupQty');

    if (img) {
      const src = item.image || item.featured_image || '';
      img.src = src ? (src.indexOf('http') === 0 ? src : `https:${src}`) : '';
      img.alt = item.product_title || item.title || '';
      img.style.display = src ? '' : 'none';
    }
    if (name) name.textContent = item.product_title || item.title || 'Product';
    if (price) price.textContent = money(item.final_line_price || item.line_price || item.price, cart && cart.currency);
    if (qty) qty.textContent = `Qty: ${item.quantity || 1}`;

    popup.hidden = false;
    document.body.classList.add('croft-cart-open');
    const closeBtn = popup.querySelector('.croft-cart-popup__close');
    if (closeBtn) closeBtn.focus();
  };

  const closePopup = () => {
    const popup = getPopup();
    if (!popup) return;
    popup.hidden = true;
    document.body.classList.remove('croft-cart-open');
  };

  const addToCart = async (form) => {
    const formData = new FormData(form);
    const addUrl = ((window.routes && routes.cart_add_url) || '/cart/add').replace(/\.js$/, '') + '.js';
    const response = await fetch(addUrl, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: formData,
    });

    if (!response.ok) {
      const err = await response.json().catch(() => ({}));
      throw new Error(err.description || err.message || 'Could not add to cart');
    }

    const item = await response.json();
    const cartRes = await fetch(((window.routes && routes.cart_url) || '/cart') + '.js');
    const cart = await cartRes.json();
    updateCartCount(cart.item_count || 0);
    openPopup(item, cart);
  };

  document.addEventListener('DOMContentLoaded', () => {
    const toggle = document.querySelector('[data-croft-menu-toggle]');
    const mobileNav = document.querySelector('[data-croft-mobile-nav]');

    if (toggle && mobileNav) {
      const setOpen = (open) => {
        mobileNav.classList.toggle('is-open', open);
        if (open) mobileNav.removeAttribute('hidden');
        else mobileNav.setAttribute('hidden', '');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      };

      toggle.addEventListener('click', () => setOpen(!mobileNav.classList.contains('is-open')));
      mobileNav.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => setOpen(false)));
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          setOpen(false);
          closePopup();
        }
      });
    } else {
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') closePopup();
      });
    }

    document.querySelectorAll('[data-croft-cart-close]').forEach((el) => {
      el.addEventListener('click', closePopup);
    });

    document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        const btn = form.querySelector('[type="submit"]');
        if (btn) {
          btn.disabled = true;
          btn.setAttribute('aria-busy', 'true');
        }
        try {
          await addToCart(form);
        } catch (error) {
          window.alert(error.message || 'Unable to add to bag');
        } finally {
          if (btn) {
            btn.disabled = false;
            btn.removeAttribute('aria-busy');
          }
        }
      });
    });

    if (reduce) return;

    const reveals = document.querySelectorAll('.croft-reveal');
    if (!reveals.length || !('IntersectionObserver' in window)) {
      reveals.forEach((el) => el.classList.add('is-in'));
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
    );

    reveals.forEach((el) => io.observe(el));
  });
})();
